import { sanitiseFileName } from "./sanitiseFileName";

function stem(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot < 0 ? name : name.slice(0, dot);
}

/** Matches web createFileUploadHandler: reserve stored filename stems across all extensions. */
export function reserveUploadName(name: string, reserved: readonly string[]): string {
  const dot = name.lastIndexOf(".");
  const extension = dot < 0 ? "" : name.slice(dot);
  const base = sanitiseFileName(stem(name));
  const taken = new Set(reserved.map(stem));
  let candidate = base;
  let suffix = 1;
  while (taken.has(candidate)) candidate = `${base}(${suffix++})`;
  return `${candidate}${extension}`;
}
